import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { ShopService } from '../../../../services/shop.service';
import { AuthService } from '../../../../services/auth.service';
import { UtilityService } from '../../../../services/utility.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { WebClientService } from "../../../../services/webclient-settings.service";
/**
 * Header Component
 */
let CheckoutComponent = class CheckoutComponent {
    constructor(httpClient, router, shopService, auth, checker, sanitizer, themeService, webSettingsService) {
        this.httpClient = httpClient;
        this.router = router;
        this.shopService = shopService;
        this.auth = auth;
        this.checker = checker;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.priceAll = 0;
        this.checkoutData = {
            name: '',
            mobile: '',
            email: '',
            city: '',
            post_code: ''
        };
        this.formDisabled = false;
        this.any = {};
        this.products = [];
        this.phoneError = true;
        this.postError = false;
        this.inputBackColor = '';
        this.successColor = '';
        this.textColor = '';
        this.inputTextColor = '';
        this.errorColor = '';
        this.secondaryColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.settingForBuyingWithBTC = this.webSettingsService.applySettings("SHOP.ALLOW_PAYING_WITH_BITCOIN_IN_SHOP");
    }
    ngOnInit() {
        this.checkoutData.shop_payment_type = 'fiat';
        this.products = this.shopService.getProducts();
        this.userData = JSON.parse(localStorage.getItem('user'));
        if (this.userData !== null) {
            this.phoneError = false;
        }
        if (this.products.length < 1) {
            this.router.navigateByUrl('shop');
        }
        this.userData = JSON.parse(localStorage.getItem('user'));
        if (this.userData) {
            this.checkoutData.name = this.userData.name;
            this.checkoutData.mobile = this.userData.mobile;
            this.checkoutData.email = this.userData.email;
            this.checkoutData.city = this.userData.city;
        }
        if (this.checkoutData.payment_type_id === 2) {
            this.checkoutData.shop_payment_type = 'crypto';
        }
        else {
            this.checkoutData.shop_payment_type = 'fiat';
        }
        if (localStorage.getItem('checkoutData')) {
            this.checkoutData = JSON.parse(localStorage.getItem('checkoutData'));
        }
        let finalFlag = true;
        this.products.forEach((product) => {
            finalFlag = finalFlag && product.product.buy_with_btc;
        });
        this.buyingWithBitcoinAllowed = this.settingForBuyingWithBTC && finalFlag;
    }
    onSelectionChange(entry) {
        this.checkoutData.shop_payment_type = entry;
    }
    submit() {
        this.checkName();
        this.checkPhone();
        this.checkPlace();
        this.checkPost();
        this.validateEmail();
        if (this.phoneError || this.addressError || this.emailError || this.nameError || this.postError) {
            this.formDisabled = true;
        }
        else {
            this.formDisabled = false;
            this.checkoutData.shop_ecurrency_id = 1;
            for (let i = 0; i < this.products.length; i++) {
                this.products[i].product_id = this.products[i].id;
                delete this.products[i].product.custom_data;
            }
            this.checkoutData.products = this.products;
            this.httpClient.post('shop/buyproducts', this.checkoutData).subscribe((result) => {
                localStorage.setItem('checkoutData', JSON.stringify(result['original']));
                this.router.navigateByUrl('shop/confirm');
            });
        }
    }
    checkPost() {
        if (this.checkoutData.post_code.length !== 5) {
            this.postError = true;
        }
        else {
            const isnum = /^\d+$/.test(this.checkoutData.post_code);
            if (isnum) {
                this.postError = false;
            }
            else {
                this.postError = true;
            }
        }
    }
    checkPhone() {
        this.phoneError = !this.checker.checkPhone(this.checkoutData.mobile);
        this.phoneError2 = this.phoneError;
        return !this.phoneError;
    }
    checkPlace() {
        if (this.checkoutData.address < 2) {
            this.addressError = true;
        }
        else {
            this.addressError = false;
        }
    }
    validateEmail() {
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(this.checkoutData.email) === false) {
            this.emailError = true;
        }
        else {
            this.emailError = false;
        }
    }
    checkName() {
        const values = this.checkoutData.name.split(' ').filter(function (v) { return v !== ''; });
        if (values.length > 1) {
            this.nameError = false;
        }
        else {
            this.nameError = true;
        }
    }
};
CheckoutComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: ShopService },
    { type: AuthService },
    { type: UtilityService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService }
];
CheckoutComponent = __decorate([
    Component({
        selector: 'ecd-checkout',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./checkout.component.html")).default
    })
], CheckoutComponent);
export { CheckoutComponent };
